/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileTag
 */
export interface FileTag {
    /**
     * 
     * @type {number}
     * @memberof FileTag
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FileTag
     */
    fileTag: string;
}

export function FileTagFromJSON(json: any): FileTag {
    return FileTagFromJSONTyped(json, false);
}

export function FileTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fileTag': json['fileTag'],
    };
}

export function FileTagToJSON(value?: FileTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'fileTag': value.fileTag,
    };
}


